<template>
  <div class="fill-height">
    <player-pain-widget
      v-if="isPlayerPain"
      :stats="playerPainStats"
      :gender="gender"
    />
    <team-pain-widget
      v-else
      :event-stats="stats"
      :today-stats="todayStats"
      :yesterday-stats="yesterdayStats"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import TeamPainWidget from '@/components/training-load/TeamPainWidget.vue'
import PlayerPainWidget from '@/components/training-load/PlayerPainWidget.vue'

export default {
  name: 'PainChart',
  components: { PlayerPainWidget, TeamPainWidget },
  props: {
    stats: {
      type: [Object, Array],
      default: () => ({})
    },
    todayStats: {
      type: Object,
      default: () => ({})
    },
    yesterdayStats: {
      type: Object,
      default: () => ({})
    },
    gender: {
      type: String,
      default: 'male'
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPlayerPain() {
      return ('highest_pain' in this.stats) && !this.removable
    },
    playerPainStats() {
      const painPerSpot = this.stats.highest_pain_per_spot
      if (Array.isArray(painPerSpot)) {
        return {}
      }
      return painPerSpot || {}
    }
  }
}
</script>
